import {
  readSessionValue,
  removeSessionValue,
  writeSessionValue,
} from "~/utils/sessionStorageValue";

const CAMPAIGN_SIGN_UP_MARK_KEY = "ph_campaign_sign_up_started_at";
const CAMPAIGN_SIGN_UP_MARK_TTL_MS = 30 * 60 * 1000;

export const markCampaignSignUpStarted = (now: number = Date.now()): void =>
  writeSessionValue(CAMPAIGN_SIGN_UP_MARK_KEY, String(now));

export const consumeCampaignSignUpMark = (
  now: number = Date.now()
): boolean => {
  const startedAt = Number(readSessionValue(CAMPAIGN_SIGN_UP_MARK_KEY));
  removeSessionValue(CAMPAIGN_SIGN_UP_MARK_KEY);

  return startedAt > 0 && now - startedAt <= CAMPAIGN_SIGN_UP_MARK_TTL_MS;
};
